var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-grid tw-grid-cols-12",class:{
        'tw-rounded-md tw-p-2 tw-px-6': _vm.hasBackground,
        'tw-bg-red-300': _vm.hasBackground && !_vm.isAsiInquiry,
        'tw-border tw-border-[color:var(--brand-primary)]': _vm.hasBackground && _vm.isAsiInquiry,
        'tw-my-4': !_vm.hasNoYSpacing,
    }},[(_vm.icon)?_c('div',{staticClass:"tw-col-span-2 tw-pr-4 tw-content-center"},[_c(_vm.icon,{tag:"component",class:{'tw-text-cyan-500': _vm.coloredIcon}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tw-content-center",class:_vm.icon ? 'tw-col-span-10' : 'tw-col-span-12'},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }